import MediaGallery from '@stories/Components/MediaGallery/MediaGallery';
import React from 'react';
import { MediaGalleryWidgetStyles as S } from './MediaGalleryWidget.styles';
const MediaGalleryWidget = (props) => {
    return (React.createElement(S.Container, { id: props.anchorId },
        React.createElement(S.Inner, { "data-mobile-stretch": true },
            React.createElement(MediaGallery, { galleryMedia: props.galleryMedia }))));
};
export default MediaGalleryWidget;
